import React, { useMemo, useState } from "react";
import Grid from "@mui/material/Grid";
import { Container, TextField, Button } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { NavLink } from "react-router-dom";
import Header from "../../components/Header/Header";
import IconButton from "@mui/material/IconButton";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Formik, Form, Field } from "formik";

const ProductionReport = () => {
  const [rowData] = useState([
    {
      name: "Table",
      sku: "Tab01023",
      category: "Table",
      salePrice: "580.00",
      cost: "308.00",
      profit: "282.00",
      margin: "48.2%",
      prodtime: "9h",
    },
  ]);

  const [columnDefs] = useState([
    {
      field: "slno.",
      headerName: "S.No.",
      sortable: true,
      filter: false,
      maxWidth: 80,
    },
    {
      field: "poid",
      headerName: "PO ID",
      sortable: true,
    },

    {
      field: "model",
      headerName: "ModelNo.",
      sortable: true,
    },
    {
      field: "qty",
      headerName: "QTY",
      sortable: true,
    },
    {
      field: "itemName",
      headerName: "Item Name",
      sortable: true,
    },
    {
      field: "status",
      headerName: "Status",
      sortable: true,
    },
    {
      field: "store",
      headerName: "Store",
      sortable: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      sortable: true,
    },
    {
      field: "deliveryDate",
      headerName: "Delivery Date",
      sortable: true,
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      sortable: true,
    },
    {
      field: "orderid",
      headerName: "Order ID",
      sortable: true,
    },
  ]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      floatingFilter: true,
      autoHeight: true,
    };
  }, []);

  return (
    <>
      <Header />
      <Container maxWidth={false}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="grid-tabs-container">
              <Grid item xs={12}>
                <div className="nav-bar">
                  <NavLink
                    to="/report/production-report"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Production Report
                  </NavLink>
                  <NavLink
                    to="/report/material-history"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Material History
                  </NavLink>
                  <NavLink
                    to="/report/raw-material"
                    activeclassname="active"
                    className="nav-custom"
                  >
                    Raw Material Report
                  </NavLink>
                </div>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <Grid container className="mt-25">
          <Grid item xs={6}>
            <h4 className="title mt-10">Production Report</h4>
          </Grid>
          <Grid item xs={6} className="search-bar">
            <Formik
              initialValues={{
                uom: "",
              }}
              onSubmit={async (values) => {
                await new Promise((r) => setTimeout(r, 500));
                // alert(JSON.stringify(values, null, 2));
                console.log(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <Form onSubmit={handleSubmit} className="d-flex">
                  <Field
                    as="select"
                    name="color"
                    className="w-100 search-input"
                  >
                    <option value="all">All</option>
                    <option value="order">Order</option>
                    <option value="display">Display</option>
                  </Field>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="search-button"
                  >
                    Search
                  </Button>
                </Form>
              )}
            </Formik>

            <div className="action-buttons">
              {/* <IconButton color="primary"><FileDownloadOutlinedIcon/></IconButton> */}
              <IconButton disabled>
                <PrintIcon />
              </IconButton>
              <IconButton disabled>
                <EditIcon />
              </IconButton>
              <IconButton disabled>
                <DeleteIcon />
              </IconButton>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className="ag-theme-alpine" style={{ height: 400 }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                rowDragManaged={true}
                defaultColDef={defaultColDef}
              ></AgGridReact>
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ProductionReport;
